const stylesFonts: Record<string, string> = {
  boldTitles: 'Bold-titles',
  regularText: 'Avenir-regular',
};

export default stylesFonts;
